import type { ThemeTypings } from '@chakra-ui/react';
import { AlertDialog, AlertDialogOverlay, AlertDialogContent, AlertDialogHeader, AlertDialogBody, AlertDialogFooter, Button } from '@chakra-ui/react'
import React, { useRef } from 'react'

function SubmitDialog({
    isOpen,
    onClose,
    body,
    header,
    colorScheme = 'primary'
}: {
    isOpen: boolean,
    onClose: () => void,
    body: React.ReactNode,
    header: React.ReactNode,
    colorScheme?: ThemeTypings["colorSchemes"]
}) {
    const savedFormCancelRef = useRef<HTMLButtonElement>(null)

    return (
        <AlertDialog
            leastDestructiveRef={savedFormCancelRef}
            isOpen={isOpen}
            onClose={onClose}
            isCentered
        >
            <AlertDialogOverlay>
                <AlertDialogContent>
                    <AlertDialogHeader fontSize="lg" fontWeight="bold">
                        {header}
                    </AlertDialogHeader>

                    <AlertDialogBody>
                        {body}
                    </AlertDialogBody>

                    <AlertDialogFooter>
                        <Button
                            ref={savedFormCancelRef}
                            colorScheme={colorScheme}
                            onClick={onClose}
                        >
                            Rozumím
                        </Button>
                    </AlertDialogFooter>
                </AlertDialogContent>
            </AlertDialogOverlay>
        </AlertDialog>
    )
}

export default SubmitDialog